import { withManagedProps } from "@made-people/managed-props";
import { BannerProps, Banner } from "@made-people/blueprint-banner";

export const CardBannerDefaults: BannerProps = {
  variants: {
    size: "portrait",
    dim: "none",
    contentPosition: "bottom-left",
  },
  layout: {
    spacing: {
      x: "none",
      y: "none",
      applySpacing: "false",
    },
    position: {
      applyPosition: "false",
      maxWidth: "none",
    },
  },
  settings: {
    image: {
      displaySize: {
        mobile: "50vw",
        tablet: "50vw",
        desktop: "15vw",
      },
    },
    heading: {
      variants: {
        headingSize: "md",
        leadSize: "sm",
      },
    },
  },
};

export const CardBanner = withManagedProps(
  "CardBanner",
  (props: BannerProps) => <Banner {...props} />,
);
